import { checkWithMediumJson } from './checkWithMediumJson';

/**
 * ตรวจสอบค่า LDL โดยใช้ค่าปกติจาก medium.json
 */
export default async (value, age, gender) => {
  return await checkWithMediumJson(value, 'LDL', gender, age, 'LDL');
};
